import {useConfig} from './ConfigProvider';

export default function StepHeader({text} ){
	const {theme} = useConfig();

	return (
		<h1 style={theme.stepHeader}>{text}</h1>
	);
}
